$(document).ready(function () {
    $('#method').click(function(){
        var elem   = $(this),
            input  = $('#balance'),
            parent = input.parent();
        
        parent.removeClass('error');
        input.val('');

        if(elem.prop('checked')){
            input.removeClass('required');
        }else{
            input.addClass('required');
        }

    })

    $('.cart-form-btn').click(function(){
        event.preventDefault();

        $('.cart form .required').each(inputCheck);

        var address = $('#address'),
            parent  = address.parent();

        if($('.select-delivery-item[data-type="delivery"]').hasClass('active')){
            if(!mapPlaceholder){
                parent.addClass('error');
                parent.find('.error-message').remove();
                parent.append('<p class="error-message">выберите точку</p>');
            }else if(address.val() == ''){
                parent.addClass('error');
                parent.find('.error-message').remove();
                parent.append('<p class="error-message">заполните поле</p>');
            }else{
                parent.removeClass('error');
            }  
        }

        if($('.cart form .error').length == 0){
            loader_on();

            var additional_phone = $('#additional-phone').val();

            if( additional_phone.indexOf('_') > 0 ){
                additional_phone = '';
            }else{
                for( var i = 0; i < 10; i++){
                    var check = additional_phone.split(i).length - 1;
                    if(check > 6){
                        additional_phone = '';
                    }
                }
            }

            var name             = $.trim($('#name').val()),
                phone            = $.trim($('#phone').val()),
                persons          = $.trim($('#persons').val()),
                method           = $('#method').prop('checked') * 1,
                balance          = $.trim($('#balance').val()),
                address          = mapAddress,
                delivery         = $('.select-delivery-item.active').data('type'),
                price            = $.trim(delivery_price),
                comment          = $.trim($('#comment').val()),
                products         = {};            

            if(delivery != 'delivery'){
                address = '';
                сrossroads = '';
                price = 0;
                delivery = 1;
            }else{
                delivery = 0;
            }

            if(method){
                balance = '';   
            }

            $('.cart-content').find('.product-quantity').each(function(){
                var elem    = $(this),
                    val     = elem.val(),
                    id      = elem.parents('.table-item').data('id');

                if(val > 0){
                    products[id] = val;
                }
            });            
            
            var result = {
                'user'  : {
                    'userName'              : name,
                    'phoneNumber'           : phone,
                    'additionalPhoneNumber' : additional_phone,
                    'numberOfPerson'        : persons,
                    'getChange'             : balance,
                    'deliveryPrice'         : price,
                    'address'               : address,
                    'comment'               : comment
                },
                'method'        : method,
                'delivery'      : delivery,
                'products'      : products,
            }

			// Days
			var date = new Date;
			date.setDate(date.getDate() + 1); // 1 Days

            sendAjax('add_order', result, function(res){
                const order_id = res.order_id
                location.href = '/success/?method=' + method + '&order_id=' + order_id;		
            });

        }else{
            var offset = $('.cart form .error').eq(0).offset().top - 80;
            $('html, body').animate({ 
                scrollTop: offset
            }, 500); 
        }      

    })

    $('.block-toggler').click(function(){
        var elem   = $(this),
            parent = elem.parent(),
            input  = parent.find('input'),
            next   = parent.next(),
            toggle = $('.' + elem.data('toggle'));

        next.find('input').val('');

        if(input.prop('checked')){
            next.slideUp(300);
            toggle.slideDown(300);
        }else{
            next.slideDown(300);
            toggle.slideUp(300);
        }
    })

    $('.select-delivery-item').click(function(){
        var elem             = $(this),
            type             = elem.data('type'),
            address          = $('.form-group.address'),
            сrossroads       = $('.сrossroads'),
            address_input    = $('#address'),
            delivery         = $('.cart-delivery-price'),
            total            = $('.cart-info-total-price');


        if(!elem.hasClass('active')){
            $('.select-delivery-item').removeClass('active');
            elem.addClass('active');

            address_input.parent().removeClass('error');

            if(type == 'delivery'){
                address.slideDown(300);
                сrossroads.slideDown(300);
                address_input.addClass('required');
                cart_widget();  
            }else{
                address.slideUp(300);
                сrossroads.slideUp(300);
                address_input.removeClass('required');
                total.text(total.text() - delivery.text());
                delivery.text(0);
            }

        }

    })

});